import { PerimetryTestType } from "../../../model/TestType";
import { isBinocularVFATestType } from "@constants/testConstants/testSpecificConstants";

export function getTestAxisDegrees(testType, asymmetry?, withSymbol = true): string | number {
  let degree = 30;
  if (
    testType === PerimetryTestType.PER_FF_120 ||
    testType === PerimetryTestType.PER_SUPERIOR36 ||
    testType === PerimetryTestType.PER_SUPERIOR64 ||
    testType === PerimetryTestType.PER_BINOCULAR3
  ) {
    degree = 70;
  } else if (isBinocularVFATestType(testType)) {
    degree = 80;
  } else if (testType === PerimetryTestType.PER_C_40 || testType === PerimetryTestType.PER_C_76) {
    degree = 30;
  } else if (testType === PerimetryTestType.PER_30_2) {
    degree = 30;
  } else if (testType === PerimetryTestType.PER_24_2 || testType === PerimetryTestType.PER_24_2C) {
    degree = 30;
    if (asymmetry) {
      return "";
    }
  } else if (testType === PerimetryTestType.PER_10_2) {
    degree = 10;
  }
  return withSymbol ? degree + "°" : degree;
}

export function getTestAxisLabelPosition(testType) {
  if (testType === PerimetryTestType.PER_FF_120 || isBinocularVFATestType(testType)) {
    return 205;
  } else if (testType === PerimetryTestType.PER_C_40 || testType === PerimetryTestType.PER_C_76) {
    return 225;
  } else if (testType === PerimetryTestType.PER_30_2) {
    return 300;
  } else if (testType === PerimetryTestType.PER_24_2 || testType === PerimetryTestType.PER_24_2C) {
    return 240;
  } else if (testType === PerimetryTestType.PER_10_2) {
    return 300;
  } else if (
    testType === PerimetryTestType.PER_SUPERIOR36 ||
    testType === PerimetryTestType.PER_SUPERIOR64
  ) {
    return 310;
  }
}
